module.exports = __webpack_public_path__ + "static/media/map-pin-outlined.7bb3c683.svg";